/** 退出桌面端：整批灯光恢复总超时（含 settle / 多设备） */
export const QUIT_LIGHTING_RESTORE_TOTAL_MS = 18_000;

/** 退出桌面端：单台设备恢复超时 */
export const QUIT_LIGHTING_RESTORE_DEVICE_MS = 10_000;

/** 星闪 HID 串行队列排空超时（退出恢复路径） */
export const XINGSHAN_SDK_CHAIN_IDLE_TIMEOUT_MS = 5_000;

/**
 * 退出恢复专用：Promise 超时 race；超时或异常时打 warn 并返回 undefined，不向外抛错。
 */
export async function runWithQuitRestoreTimeout<T>(
  label: string,
  fn: () => Promise<T>,
  timeoutMs: number
): Promise<T | undefined> {
  if (timeoutMs <= 0) {
    try {
      return await fn();
    } catch (e) {
      console.warn(`[QuitRestore] ${label} 失败，跳过:`, e);
      return undefined;
    }
  }

  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      fn(),
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => {
          reject(
            new Error(`[QuitRestoreTimeout] ${label} 超过 ${timeoutMs}ms`)
          );
        }, timeoutMs);
      }),
    ]);
  } catch (e) {
    console.warn(`[QuitRestore] ${label} 超时或失败，跳过:`, e);
    return undefined;
  } finally {
    if (timer) clearTimeout(timer);
  }
}
